const homepage = {
    success: true,
    data: {
        components: [
            {
                key: "header",
                type: "carousel",
                visible: true,
                order: 1,
                data: {
                    title: "",
                    data: [
                        {
                            image:
                                "https://img.freepik.com/free-vector/creative-business-strategy-idea-illustration-concept_1344-194.jpg",
                            title: "Empowering Your Digital Future",
                            subtitle:
                                "Helping your business thrive in the AI-driven digital era.",
                        },
                        {
                            image:
                                "https://img.freepik.com/free-vector/people-starting-business-project_23-2148866841.jpg",
                            title: "Redefine What’s Possible",
                            subtitle:
                                "From Ideas to Impact —Innovation Driving Business Growth.",
                        },
                        {
                            image:
                                "https://img.freepik.com/free-vector/men-teamwork-with-gears-induatry-bulb-idea_24877-54770.jpg",
                            title: "Transform. Accelerate. Lead.",
                            subtitle:
                                "From Strategy to Prototyping — End-to-End Digital Innovation for Growth",
                        },
                    ],
                },
            },
            {
                key: "services",
                type: "carousel",
                visible: true,
                order: 2,
                data: {
                    title: "",
                    data: [
                        {
                            title: "Mobile App Development",
                            description: "Build. Launch. Engage.",
                            icon: "mobile" // 📱
                        },
                        {
                            title: "Cloud Services",
                            description: "Scale effortlessly, operate securely.",
                            icon: "cloud" // ☁️
                        },
                        {
                            title: "Business Consulting",
                            description: "Transform strategy into results.",
                            icon: "briefcase" // NEW ✅
                        },
                        {
                            title: "Solution Implementation",
                            description: "From concept to execution.",
                            icon: "tools" // 🛠
                        },
                        {
                            title: "Payment Gateway Integration",
                            description: "Pay easy, pay safe.",
                            icon: "credit_card" // 🔒💳 NEW ✅
                        },
                        // {
                        //     title: "Mobility Solutions",
                        //     description: "Work anywhere, anytime.",
                        //     icon: "car" // 🚗 NEW ✅ (Mobility)
                        // },
                        {
                            title: "Support & Adoption",
                            description: "We’ve got you covered. Train. Guide. Excel.",
                            icon: "headset" // 🎧 NEW ✅ (Support)
                        },
                        {
                            title: "Data Analytics",
                            description: "Data into decisions.",
                            icon: "chart_line" // 📈 NEW ✅
                        },
                        {
                            title: "Digital Marketing",
                            description:
                                "Boost your brand’s online presence with data-driven marketing strategies.",
                            icon: "bullhorn" // 📢 NEW ✅
                        }
                    ]

                },
            },
            {
                key: "tech",
                type: "techStack",
                visible: true,
                order: 3,
                data: {
                    title: "Our Tech Stack Expertise",
                    data:
                        [
                            { name: "Node JS", icon: "node" },
                            { name: "React JS", icon: "react" },
                            { name: "Vue JS", icon: "vue" },
                            { name: "React Native", icon: "react" },
                            { name: "Java", icon: "java" },
                            { name: "AWS", icon: "aws" },
                            { name: "Python", icon: "python" },
                            { name: "Machine Learning", icon: "ml" },
                            { name: "Heroku", icon: "heroku" },
                        ]

                },
            },
            {
                key: "salesforcetech",
                type: "salesforcetechStack",
                visible: true,
                order: 4,
                data: {
                    title: "Salesforce Products We Support",
                    data:
                        [
                            { name: "Salesforce APEX", icon: "/images/Salesforce-Corporate-Logo-Horiz-RGB.svg" },
                            { name: "Salesforce Lightning", icon: "/images/lightning.svg" },
                            { name: "Salesforce LWC", icon: "/images/salesforce.svg" },
                            { name: "Data Cloud", icon: "/images/datacloud.svg" },
                            { name: "Marketing Cloud", icon: "/images/marketing.svg" },
                            { name: "Sales Cloud", icon: "/images/salescloud.svg" },
                            { name: "Service Cloud", icon: "/images/servicecloud.svg" },
                            { name: "Tableau", icon: "/images/tableau.svg" },
                            { name: "Slack", icon: "/images/slack.svg" },
                            { name: "Mulesoft", icon: "/images/mulesoft.svg" },
                        ]

                },
            },
            {
                key: "crmservices",
                type: "carousel",
                visible: true,
                order: 5,
                data: {
                    title: "",
                    data: [
                        {
                            title: "Salesforce® Marketing Cloud Staffing Services",
                            description: "Marketing Cloud empowers enterprises to run highly personalized, result-driven campaigns across every channel. Our certified experts ensure you have the right talent, strategy, and execution to unlock the true potential of Salesforce Marketing Cloud. From automation to analytics, we help your marketing team deliver outstanding customer experiences that lead to measurable business growth.",
                            icon: "link" // 📱
                        },
                        {
                            title: "Salesforce® CRM Health Check",
                            description: "Our Salesforce CRM Health Check provides a detailed evaluation to uncover hidden inefficiencies, integration gaps, and performance issues. We deliver a clear, actionable improvement plan covering data quality, security, automation, and user adoption. With quick remediation steps, your CRM becomes faster, smarter, and fully aligned with your revenue goals.",
                            icon: "health" // ☁️
                        },
                        {
                            title: "Salesforce® Consulting Services",
                            description: "We collaborate closely with business leaders to design Salesforce solutions that enhance processes, build stronger customer relationships, and accelerate digital transformation. Our certified consultants focus on gaining deep insights into your workflows and challenges, enabling us to deliver scalable, ROI-driven strategies that support long-term success.",
                            icon: "hexagon" // NEW ✅
                        },
                        {
                            title: "Salesforce® Implementation Services",
                            description: "Launching Salesforce the right way is crucial for success. Our Salesforce Implementation Services ensure a strategic rollout aligned with your goals — from tailored configurations to automation and analytics setup. We design smooth, scalable workflows that empower your teams to perform better from day one while maintaining industry-leading compliance and best practices.",
                            icon: "rocket" // 🛠
                        },
                        {
                            title: "Salesforce® Integration Services",
                            description: "Our Salesforce Integration Services connect your CRM seamlessly with essential business applications like WhatsApp, Jira, accounting systems, ERPs, and more. We eliminate siloed data and manual tasks by enabling real-time sync across platforms. The result — a unified ecosystem that boosts efficiency, enhances collaboration, and improves decision-making.",
                            icon: "plug" // 🔒💳 NEW ✅
                        },
                        {
                            title: "Salesforce Data Cloud + AI + Tableau",
                            description: "Unify every data source into a single intelligent platform with Salesforce Data Cloud — supercharged with AI insights and Tableau analytics. From predictive intelligence to dynamic dashboards and customer-360 visibility, this powerful combination helps businesses make decisions in real time. See deeper, act faster, and drive strategy with data that truly works for you.",
                            icon: "network" // 🚗 NEW ✅ (Mobility)
                        },
                        {
                            title: "Salesforce® Support Services",
                            description: "Our Salesforce Support Services provide full lifecycle assistance — from resolving operational issues to implementing enhancement requests. Whether it’s user training, bug fixes, security updates, or continuous performance monitoring, we ensure your Salesforce environment always runs smoothly. Focus on innovation while we safeguard your CRM success every day.",
                            icon: "headset" // 🎧 NEW ✅ (Support)
                        },
                        {
                            title: "Salesforce® Lightning Migration",
                            description: "Transition to Salesforce Lightning with confidence. Our expert-led Lightning Migration Services modernize your org for a faster, smarter, and more intuitive Salesforce experience. From UI redesign to rebuilding workflows and security mapping, we handle every detail with zero disruption. Unlock the full potential of Lightning — performance upgrades, enhanced productivity, and future-ready innovation.",
                            icon: "code" // 📈 NEW ✅
                        },
                        {
                            title: "Salesforce® Development Services",
                            description:
                                "Our Salesforce Development Services help transform your CRM into a tailored business engine. Whether building custom applications, automating complex processes, or integrating external platforms, we craft solutions that scale with your growth. With certified developers by your side, you get secure, high-performance enhancements that elevate your Salesforce capability to its best.",
                            icon: "play" // 📢 NEW ✅
                        }
                    ]

                },
            },
            {
                key: "clients",
                type: "carousel",
                visible: true,
                order: 6,
                data: {
                    title: "Our Clients",
                    data: [
                        {
                            name: "Jaideep",
                            icon: "https://media.licdn.com/dms/image/v2/C560BAQEOT4kQA7K04A/company-logo_200_200/company-logo_200_200/0/1630640855520/jaideep_ispat_alloys_pvt_ltd_logo?e=2147483647&v=beta&t=quV-cAD28dEKi4axr4sf9B4uLzgFMgm-rGwJeHzuTjc"
                        },
                        {
                            name: "Welspun",
                            icon: "https://companieslogo.com/img/orig/WELSPUNIND.NS-98ce7058.png?t=1729839187"
                        },
                        {
                            name: "JK Paper",
                            icon: "https://companieslogo.com/img/orig/JKPAPER.NS_BIG-e57df226.png?t=1728895746"
                        }
                    ]

                },
            },
            {
                key: "ourwork",
                type: "ourwork",
                visible: true,
                order: 7,
                data: {
                    title: "Our Products",
                    data: [
                        {
                            title: "SFA (Sales Force Automation)",
                            category: "SAAS",
                            description:
                                "Streamline sales processes and boost team productivity.",
                            link: "sfaapp.com",
                            technologies: ["React Native"],
                            image:
                                "/images/sfa.png",
                        },
                        {
                            title: "DMS (Dealer Management System)",
                            category: "Enterprise",
                            description:
                                "Efficiently manage dealer networks and operations.",
                            link: "dmsplatform.com",
                            technologies: ["React Native"],
                            image:
                                "/images/dms.png",
                        },
                        {
                            title: "Loyalty Programs",
                            category: "CRM",
                            description:
                                "Enhance customer engagement and retention with rewards.",
                            link: "salesforcecrm.com",
                            technologies: ["Vue Js"],
                            image:
                                "/images/loyality.png",
                        },
                        {
                            title: "E-Commerce Portal",
                            category: "CRM",
                            description:
                                "Launch and manage online sales effortlessly.",
                            link: "salesforcecrm.com",
                            technologies: ["React Js"],
                            image:
                                "/images/e-com.png",
                        },
                    ],
                },
            },
            {
                key: "about",
                type: "aboutCompany",
                visible: true,
                order: 8,
                data: {
                    title: "About Us",
                    data: [
                        {
                            title: "Who We Are",
                            text: "We provide innovative tech solutions that help businesses scale efficiently.",
                            quote:
                                "At Unipro World, we help businesses thrive in the digital era. From AI-driven solutions and mobile apps to cloud services and analytics, we deliver end-to-end technology and consulting that drive growth, innovation, and efficiency. Our mission is to transform ideas into actionable solutions and empower organizations to adapt, lead, and succeed.",
                            image:
                                "https://plus.unsplash.com/premium_photo-1733306503329-7a8c701fa9ad?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=870",
                            reverse: false,
                        },
                        {
                            title: "What We Do",
                            text: "Our expert team turns complex problems into seamless digital experiences.",
                            quote:
                                "we specialized in building smart, scalable solutions around SFA, DMS ,Loyality, E com portal particularly tailored for clients in various sectors.",
                            image:
                                "https://plus.unsplash.com/premium_photo-1733306696471-807493ff845b?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=870",
                            reverse: true,
                        },
                    ],
                },
            },
            {
                key: "review",
                type: "carousel",
                visible: true,
                order: 9,
                data: {
                    title: "Customer Testimonials",
                    data: [
                        {
                            title: "Round-the-Clock Support & Efficient Improvements",
                            description:
                                "As we go live with our applications for the new business area 'Pipes', I wanted to take a moment to sincerely thank you for your continued support over the years. The Salesforce platform, along with the SFA and DMS apps, has been instrumental in driving our growth. Even after four years, your unwavering support and timely enhancements have helped us expand and adapt seamlessly. We truly appreciate all the hard work, dedication, and partnership you have extended to us. Looking forward to achieving many more milestones together!",
                            postedby: {
                                name: "vaishali jain",
                                profileimage:
                                    "https://img.freepik.com/free-photo/photo-handsome-unshaven-guy-looks-with-pleasant-expression-directly-camera_176532-8164.jpg",
                                company: "IT, Steel Industry",
                            },
                        },
                        {
                            title: "Seamless Digital Transformation",
                            description:
                                "From strategy to implementation, Unipro’s team guided us every step. Truly seamless. Business head, Hotel industry.",
                            postedby: {
                                name: "Vineet Sangwan",
                                profileimage:
                                    "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
                                company: "IT, Hotel industry",
                            },
                        },
                        {
                            title: "Flawless Implementation, Ongoing Support",
                            description:
                                "The team at Unipro World not only implemented our Salesforce platform and mobile apps flawlessly but also provided continuous guidance and support. Their approach to understanding our business needs and delivering tailored solutions has been outstanding. We look forward to many more successful projects together. Cement Industry",
                            postedby: {
                                name: "Vineet Sangwan",
                                profileimage:
                                    "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
                                company: "IT, Cement Industry",
                            },
                        },
                        {
                            title: "A Trusted Partner in Digital Growth",
                            description:
                                "We partnered with Unipro World to implement a full-scale digital transformation strategy. From business consulting to solution deployment, their team was responsive, knowledgeable, and collaborative.We highly recommend Unipro World to any organization looking to embrace the future of digital. Head of Operations, Paper Industry",
                            postedby: {
                                name: "Vineet Sangwan",
                                profileimage:
                                    "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
                                company: "IT, Paper Industry",
                            },
                        },
                        {
                            title: "Proactive Support, Lasting Impact",
                            description:
                                "The team’s dedication, technical expertise, and proactive support make them a true partner in growth. We are excited to continue this journey and achieve new milestones together. CTO, Poly Films Industry",
                            postedby: {
                                name: "Vineet Sangwan",
                                profileimage:
                                    "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
                                company: "IT, Poly Films Industry",
                            },
                        },
                        {
                            title: "Innovating for a Competitive Edge",
                            description:
                                "Working with Unipro World has been a game-changer for our organization. Their end-to-end digital solutions — from cloud migration to mobile app development — have helped us innovate and stay ahead. Paint Industry",
                            postedby: {
                                name: "Vineet Sangwan",
                                profileimage:
                                    "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
                                company: "IT, Paint Industry",
                            },
                        },
                        {
                            title: "Hands-On Support, Lasting Results",
                            description:
                                "Unipro World’s approach is very practical. They don’t just implement technology—they make sure our team can fully leverage it. Steel Industry",
                            postedby: {
                                name: "Vineet Sangwan",
                                profileimage:
                                    "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
                                company: "IT, Steel Industry",
                            },
                        },
                        {
                            title: "Practical Solutions That Empower",
                            description:
                                "Unipro World’s approach is very practical. They don’t just implement technology—they make sure our team can fully leverage it. FMCG Industry",
                            postedby: {
                                name: "Vineet Sangwan",
                                profileimage:
                                    "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
                                company: "IT, FMCG Industry",
                            },
                        },
                    ],
                },
            },
            {
                key: "heroanimated",
                type: "animation",
                visible: true,
                order: 10,
                data: {
                    title: "",
                    data: [
                        "WE UNDERSTAND YOUR NEEDS",
                        "WE DESIGN SOLUTIONS THAT FIT",
                        "YOUR SUCCESS IS OUR PRIORITY",
                    ],
                },
            },
            //  {
            //     key: "team",
            //     type: "ourteam",
            //     visible: false,
            //     order: 10,
            //     data: {
            //         title: "Our Team",
            //         data: [
            //             {
            //                 name: "Ajay Verma",
            //                 role: "Founder",
            //                 img_url:
            //                     "https://img.freepik.com/free-photo/business-concept-smiling-thoughtful-handsome-man-standing-white-isolated-background-touching-his-chin-with-hand_1258-80750.jpg",
            //             },
            //             {
            //                 name: "Bittu Gupta",
            //                 role: "Founder",
            //                 img_url:
            //                     "https://img.freepik.com/free-photo/isolated-image-positive-fashionable-young-man-with-stylish-hairdo-bristle-smiling-camera_343059-3558.jpg",
            //             },
            //             {
            //                 name: "Avinash Garg",
            //                 role: "Founder",
            //                 img_url:
            //                     "https://img.freepik.com/free-photo/half-length-close-up-portrait-young-hindoo-man-white-shirt-blue_155003-28522.jpg",
            //             },
            //             {
            //                 name: "Ravindar",
            //                 role: "Developer",
            //                 img_url:
            //                     "https://img.freepik.com/free-photo/half-length-close-up-portrait-young-hindoo-man-white-shirt-blue-space_155003-26771.jpg",
            //             },
            //             {
            //                 name: "Adarsh",
            //                 role: "Co-founder & CTO",
            //                 img_url:
            //                     "https://img.freepik.com/free-photo/business-concept-smiling-thoughtful-handsome-man-standing-white-isolated-background-touching-his-chin-with-hand_1258-80750.jpg",
            //             },
            //             {
            //                 name: "Nazim",
            //                 role: "Developer",
            //                 img_url:
            //                     "https://img.freepik.com/free-photo/young-joyful-student-man-holding-thumb-up-isolated_171337-14947.jpg",
            //             },
            //             {
            //                 name: "Rohit",
            //                 role: "Developer",
            //                 img_url:
            //                     "https://img.freepik.com/free-photo/half-length-close-up-portrait-young-hindoo-man-white-shirt-blue-space_155003-26776.jpg",
            //             },
            //             {
            //                 name: "Preeti",
            //                 role: "Developer",
            //                 img_url:
            //                     "https://img.freepik.com/free-photo/serious-man-isolated-orange-background-confident-person-looking-camera_482257-25138.jpg",
            //             },
            //         ],
            //     },
            // },
        ],
    },
};

export default homepage;
